<template>
  <div>
    <div v-if="loading" class="loading">
      <div class="spinner" />
    </div>
    <CenteredContent :item="contentObj" :showBackButton="false" />
  </div>
</template>

<script setup>
const props = defineProps({
  url: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: '',
  },
})

const content = ref('')
const loading = ref(true)
const errorText = ref('Content could not be loaded')

const contentObj = computed(() => {
  if (!content.value) return {}

  return {
    title: props.title,
    sezioneContenutoPagina: [
      {
        __typename: 'testo_Entry',
        text: content.value,
      },
    ],
  }
})

onMounted(async () => {
  try {
    loading.value = true
    const response = await fetch(props.url)
    const data = await response.json()
    content.value = data?.success ? data.content : errorText.value
  } catch (error) {
    content.value = errorText.value
  } finally {
    loading.value = false
  }
})
</script>

<style lang="scss">
@import './style.scss';
</style>
